import {listPrescription} from '@/api'

export default {
    props: {
        prescriptionDialogVisible: false
    },
    data() {
        return {
            userInfo: null,
            headImg: "",
            sysName: "",
            prescriptionList: [],
            prescriptionCount: 20,
            queryParams: {
                docId: null,
                preName: null
            },
            // 当前页码
            currentPage: 0,
            // 每页展示数量
            pageSize: 10,
            searchPreName: null,
            queryDocId: null,
            pageType: null,
            choosPreId: null,
            choosePrescriptionDialogVisible: false, // 导入处方
            // 加载时的文本提示
            loadMoreStatus: "noMore",
            lastPage: false, // 是否是最后一页
            chooseSelfTempData: {
                preId: null,
                preName: null,
                instructions: null,
                medInfo: null,
                billingType: null,
                billingTypeName: null
            },
            chooseTempData: {
                tempId: null,
                tempName: null,
                wayFrom: null,
                medInfo: null
            },
            newRuleOpen: false,
        }
    },

    created() {
        this.newRuleOpen = window.sessionStorage.getItem('newRuleOpen');
        // console.log(window.sessionStorage.getItem("user"));
        this.userInfo = JSON.parse(window.sessionStorage.getItem("user"));
        this.headImg = this.userInfo.avatar;
        this.sysName = this.userInfo.nickName;
        // console.log(this.sysName);
        this.billingType = window.sessionStorage.getItem('billingType');
        let preId = window.sessionStorage.getItem('choosePreId');
        if (preId !== null) {
            this.choosePreId = parseInt(preId);
        }
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo"));
        if (this.doctorInfo !== null && this.doctorInfo !== undefined && this.doctorInfo !== "") {
            this.queryDocId = this.doctorInfo.doctorId;
            this.prescriptionlist = [];
            this.getPrescriptionList();
        }
    },


    methods: {
        // 选择自建处方
        choosePrescription(item) {
            this.choosePrescriptionDialogVisible = !this.choosePrescriptionDialogVisible;
            this.chooseSelfTempData.preId = item.preId;
            this.chooseSelfTempData.preName = item.preName;
            this.chooseSelfTempData.instructions = item.instructions;
            this.chooseSelfTempData.billingType = item.billingType;
            if (item.billingType !== null && item.billingType !== "" && item.billingType !== undefined) {
                if (item.billingType === '0') {
                    this.chooseSelfTempData.billingTypeName = "颗粒";
                } else if (item.billingType === '1') {
                    this.chooseSelfTempData.billingTypeName = "饮片";
                } else if (item.billingType === '2') {
                    this.chooseSelfTempData.billingTypeName = "膏方";
                } else if (item.billingType === '3') {
                    this.chooseSelfTempData.billingTypeName = "水丸";
                }
            } else {
                this.chooseSelfTempData.billingTypeName = "颗粒";
            }
            let docPrescriptionMedicineArray = item.docPrescriptionMedicineList;
            let medInfo = "";
            if (docPrescriptionMedicineArray.length > 0) {
                docPrescriptionMedicineArray.forEach((medic) => {
                    medInfo += medic.meName;
                    if (medic.decoctionId !== null && medic.decoctionId !== undefined && medic.decoctionId !== '') {
                        medInfo += "(" + medic.decoctionName + ")";
                    }
                    if (medic.decoctWay !== null && medic.decoctWay !== undefined && medic.decoctWay !== '') {
                        medInfo += "(" + medic.decoctWay + ")";
                    }
                    if (item.billingType === "0") {
                        if (medic.newGCount === null) {
                            medic.newGCount = medic.gCount;
                        }
                        if (this.newRuleOpen) {
                            medic.gCount = parseFloat(parseFloat(medic.newGCount) * parseFloat(medic.newRatio)).toFixed(2);
                        } else {
                            medic.gCount = medic.newGCount;
                        }
                    } else {
                        medic.newGCount = medic.gCount;
                    }
                    medInfo += "(" + medic.newGCount + "g)" + ",";
                })
            }
            medInfo = medInfo.substring(0, medInfo.length - 1).replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
            this.chooseSelfTempData.medInfo = medInfo;
        },


        // 替换已有药材
        replaceSelfTempChoose(billingType, preId) {
            this.choosePreId = preId;
            if (this.billingType === billingType) {
                window.sessionStorage.removeItem("medicineList");
                window.sessionStorage.removeItem("preId");
                window.sessionStorage.setItem("choosePreId", preId);
                window.sessionStorage.setItem("addType", "replace");
                this.$emit('preDrawerStatus', false);
            } else {
                this.$confirm('当前所选自建处方剂型与开方剂型不一致，替换将同步修改开方剂型, 是否继续?', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    window.sessionStorage.removeItem("medicineList");
                    window.sessionStorage.removeItem("preId");
                    window.sessionStorage.setItem("choosePreId", preId);
                    window.sessionStorage.setItem("addType", "replace");
                    window.sessionStorage.setItem("billingType", billingType);
                    this.$emit('preDrawerStatus', false);
                }).catch(() => {
                    console.log('用户取消更换');
                })

            }

        },

        // 追加到已有药材
        addSelfTempChoose(billingType, preId) {
            this.choosePreId = preId;
            if (this.billingType === billingType) {
                window.sessionStorage.removeItem("preId");
                window.sessionStorage.setItem("choosePreId", preId);
                window.sessionStorage.setItem("addType", "add");
                window.sessionStorage.setItem("billingType", billingType);
                this.$emit('preDrawerStatus', false);
            } else {
                this.$confirm('当前所选自建处方剂型与开方剂型不一致，追加将以替换的形式同步修改开方剂型和药品, 是否继续?', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    window.sessionStorage.removeItem("medicineList");
                    window.sessionStorage.removeItem("preId");
                    window.sessionStorage.setItem("choosePreId", preId);
                    window.sessionStorage.setItem("addType", "replace");
                    window.sessionStorage.setItem("billingType", billingType);
                    this.$emit('preDrawerStatus', false);
                }).catch(() => {
                    console.log('用户取消更换');
                })
            }
        },
        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },

        searchPrescriptionList() {
            this.prescriptionlist = [];
            this.getPrescriptionList();
        },

        // 获取医生常用药方
        getPrescriptionList() {
            this.queryParams.docId = parseInt(this.queryDocId);
            this.queryParams.preName = this.searchPreName;
            // this.queryParams.billingType = this.billingType;
            this.queryParams.pageNum = this.currentPage;
            this.queryParams.pageSize = this.pageSize;
            this.queryParams.reasonable = "false";
            listPrescription(this.queryParams).then(response => {
                if (response.data.rows !== null && response.data.rows !== undefined) {
                    if (response.data.rows.length < this.pageSize) {
                        this.lastPage = true;
                    }
                    this.prescriptionList = this.prescriptionlist.concat(response.data.rows);

                    this.prescriptionList.forEach(item => {
                        if (item.billingType !== null && item.billingType !== "" && item.billingType !== undefined) {
                            if (item.billingType === '0') {
                                item.billingTypeName = '颗粒';
                            } else if (item.billingType === '1') {
                                item.billingTypeName = '饮片';
                            } else if (item.billingType === '2') {
                                item.billingTypeName = '膏方';
                            } else if (item.billingType === '3') {
                                item.billingTypeName = '水丸';
                            }
                        } else {
                            item.billingTypeName = '颗粒';
                        }
                        const medicineList = item.docPrescriptionMedicineList;
                        let medInfo = "";
                        if (medicineList.length > 0) {
                            medicineList.forEach((medic) => {
                                medInfo += medic.meName;
                                if (medic.decoctionId !== null && medic.decoctionId !== undefined && medic.decoctionId !== '') {
                                    medInfo += "(" + medic.decoctionName + ")";
                                }
                                if (medic.decoctWay !== null && medic.decoctWay !== undefined && medic.decoctWay !== '') {
                                    medInfo += "(" + medic.decoctWay + ")";
                                }
                                if (item.billingType === "0") {
                                    if (medic.newGCount === null) {
                                        medic.newGCount = medic.gCount;
                                    }
                                    if (this.newRuleOpen) {
                                        medic.gCount = parseFloat(parseFloat(medic.newGCount) * parseFloat(medic.newRatio)).toFixed(2);
                                    } else {
                                        medic.gCount = medic.newGCount;
                                    }
                                } else {
                                    medic.newGCount = medic.gCount;
                                }
                                medInfo += "(" + medic.newGCount + "g)" + ",";
                            })
                        }
                        medInfo = medInfo.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                        item.medInfo = medInfo.substring(0, medInfo.length - 1);
                    })
                }
                this.total = response.data.total;
            });
        },

        loadMorePrescription() {
            if (this.lastPage) {
                this.loadMoreStatus = "noMore";
            } else {
                this.loadMoreStatus = "loading";
                // 将页码+1
                this.currentPage++;
                this.getPrescriptionList();
            }
        },
    }
}